<div class="bg-gray-50 py-24">
  <div class="mx-auto max-w-7xl px-4 sm:px-5 md:px-0">
    <div class="mx-auto max-w-4xl text-center">
      <p class="text-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-tight">
        Por que escolher a Casato Brasil
      </p>
      <p class="mt-5 text-center text-gray-500 text-lg sm:text-xl font-normal font-['Inter'] leading-relaxed">
        Tecnologia e inteligência para ajudar você a entender oportunidades em leilão com mais segurança e confiança.
      </p>
    </div>

    <div class="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3">
      @for (item of items; track item.title) {
        <div class="self-stretch rounded-md bg-white p-6 shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-gray-100">
          <div class="flex flex-col gap-2">
            <div class="text-gray-900 text-lg font-semibold font-['Inter'] leading-snug">
              {{ item.title }}
            </div>
            <div class="text-gray-500 text-base font-normal font-['Inter'] leading-normal">
              {{ item.description }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
